export default __webpack_public_path__ + "static/media/users-icon-side-right.d5c44a35.svg";